export default {
  fieldStatus: {
    true: "显示",
    false: "隐藏"
  },
  recommendStatus: {
    true: "取消推荐",
    false: "推荐"
  },
  hotStatus: {
    true: "取消热点",
    false: "热点"
  },
  newestStatus: {
    true: "取消最新",
    false: "最新"
  },
  topStatus: {
    true: "取消置顶",
    false: "置顶"
  },
  //搜索引擎收录状态
  inclusionSate: {
    true: "已收录",
    false: "未收录"
  },
  dragType: {
    before: "above",
    after: "below",
    inner: "bottom_asc"
  },
  contentApi: {
    top: {
      url: 'top',
      true: '置顶',
    },
    hot: {
      url: 'hot',
      true: '热点',
    },
    newest: {
      url: 'newest',
      true: '最新',
    },
    pcShow: {
      url: 'updateShow',
      false: '隐藏',
      true: '显示'
    },
    recommend: {
      url: 'recommend',
      true: '推荐',
    }
  },
  attribute: {
    false: '取消',
    true: ''
  },
  viewType: 1,
  menuType: {
    'column':223,
    'content':224
  },
  pageType: {
    1: '综合',
    2: '列表',
    3: '详情'
  },
  imageWater:{
    1: '取消',
    0: '添加'
  },
  isOpenReview:{
    true: '是',
    false: '否'
  },
  reviewLevel:[
    {
      id: 1,
      name: '一级审核'
    },
    {
      id: 2,
      name: '二级审核'
    },
    {
      id: 3,
      name: '三级审核'
    },
    {
      id: 4,
      name: '四级审核'
    },
    {
      id: 5,
      name: '五级审核'
    }
  ],
  businessReminding:{
    0:"个人",
    1:"企业"
  },
  emailState:{
    true:"启用",
    false:"停用"
  },
  contentReviewState:{//用于审核任务列表中
    0: '终审驳回',
    1:'待审核',
    99999: '审核通过'
  },
  contentAuditState:{//用于内容列表中
    0: '草稿',
    2: '终审驳回',
    1:'待审核',
    99999: '审核通过'
  },
  checkState:{
    0: '终审驳回',
    1: '审核通过',
    2: '审核不通过',
    3: '审核驳回',
    4: '待审核',
    99999: '终审通过'
  },
  formStatus:{//万能表单中的表单状态
    0: '全部',
    1: '待审核',
    2: '有效',
    3: '无效'
  },
  useState: {
    0: '停用',
    1: '开启'
  },
  equipment: {
    1: '电脑',
    2: '手机'
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/config.js